import { Modal } from 'antd';
import arrow from 'assets/Icons/arrow.svg';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import uuid from 'utils/uuid';
import Text from './Text';
type IDeviceNumberPickerProps = {};
type IDeviceNumberPickerRef = {
  open: () => Promise<number | null>;
  close: () => void;
};
const stations = Array.from(Array(4).keys()).map(number => ({
  id: uuid(),
  number: number + 1,
}));

export const DeviceNumberPickerRef = React.createRef<IDeviceNumberPickerRef>();
const DeviceNumberPickerContext = forwardRef<IDeviceNumberPickerRef, IDeviceNumberPickerProps>((props, ref) => {
  const [visible, setOpen] = useState(false);
  const callbackResolve = useRef<(value: number | null) => void>(() => undefined);
  const handleOpen: IDeviceNumberPickerRef['open'] = () => {
    setOpen(true);
    return new Promise((resolve) => {
      callbackResolve.current = resolve;
    });
  };

  const handleClose: IDeviceNumberPickerRef['close'] = () => {
    callbackResolve.current(null);
    setOpen(false);
  };

  const handleChooseDevice = (number: number) => {
    callbackResolve.current(number);
    handleClose();
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: handleClose,
  }));

  return (
    <>
      <Modal styles={{ body: { padding: 0 } }} centered closable={false} footer={null} open={visible} onCancel={handleClose} width={'1000px'} >
        <Container>
          <Header>
            <Text textTransform='uppercase' color={'#FFFFFF'} variant='H5'>Choose Station</Text>
          </Header>
          <ShopList>
            {stations.map((shop, index) => (
              <ShopItem onClick={() => handleChooseDevice(index + 1)} key={shop.id}>
                <Text variant='H1'>Device {index + 1}</Text>
                <img src={arrow} />
              </ShopItem>
            ))}
          </ShopList>
          <Actions>
            <button type='button' className='btn btn-close' onClick={handleClose}>
              <span>Cancel</span>
            </button>
          </Actions>
        </Container>
      </Modal>
    </>
  );
});

DeviceNumberPickerContext.displayName = 'DeviceNumberPickerContext';
const DeviceNumberPicker = {
  Portal: () => <DeviceNumberPickerContext ref={DeviceNumberPickerRef} />,
  open: () => DeviceNumberPickerRef.current?.open(),
  close: () => DeviceNumberPickerRef.current?.close(),
};

export default DeviceNumberPicker;

const Container = styled.div`
  background: #F6F8FC;
`;

const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding: 16px;
  box-shadow: 0px -4px 8px 0px #00000026;


  button.btn {
    display: flex;
    width: 100%;
    height: 56px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    background: #D4D7E4;

    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
    }

    &:disabled {
      opacity: 0.5;
    }
  }
`;

const ShopItem = styled.button`
  display: flex;
  background-color: #E8F3FF;
  box-shadow: 0px 3px 4px 0px #00000026;
  border-radius: 4px;
  padding: 24px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-width: 200px;
`;

const ShopList = styled.div`
  display: grid;
  grid-gap: 24px;
  padding: 24px;
  grid-template-columns: repeat(2, 1fr);
`;

const Header = styled.div`
  background-color: #232F3E;
  display: flex;
  justify-content: center;
  padding: 16px;
`;